import styled from "styled-components";
import { camelCaseToTitle } from "../../../../../../../helpers/StringHelper";

const Style = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  .tag {
    padding: 4px 6px;
    border: 1px solid #D0D5DD;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    color: #101828;
  }
`;

const renderInfoShared = (items = [], id, t = (s) => s) => (
  <Style>
    {items.map((it, i) => (
      <div key={`${it}-${i}-${id}`} className="tag">
        {t(camelCaseToTitle(it))}
      </div>
    ))}
  </Style>
)

export const getColumns = ({ t = (s) => s, hasInfoShared = true }) => {
  const _cols = [
    {
      title: t('Source'),
      dataIndex: 'sourceName',
      key: 'sourceName',
      ellipsis: true,
      render: (name, data) => data.isOwnData ? t('Own Data') : name,
      className: 'first-cell',
    },
  ];
  if (hasInfoShared) {
    _cols.push({
      title: t('Information Shared'),
      dataIndex: 'shared',
      key: 'shared',
      render: (val, all) => renderInfoShared(val, all.id, t),
      width: '70%',
    })
  }
  return _cols;
};
